import React from 'react';
import styles from '../../../styles/DocumentManagement.module.css';
import buttonStyles from '../../../styles/Buttons.module.css';
import { Document } from '../../../types/Document';

interface DocumentViewerProps {
  document: Document | null;
  isExpired: boolean;
  handleDocumentDownload: (docID: string) => void;
}

const DocumentViewer: React.FC<DocumentViewerProps> = ({
  document,
  isExpired,
  handleDocumentDownload,
}) => {
  if (!document) {
    return <span className={styles.textMuted}>No document uploaded</span>;
  }

  return (
    <div className={styles.documentViewerBox}>
      <div className={styles.documentViewerRow}>
        <div className={styles.documentTextBlockGrid}>
          <div className={styles.documentLabel}>Title:</div>
          <div className={styles.documentValue}>{document.title || <span className={styles.textMuted}>N/A</span>}</div>
          <div className={styles.documentLabel}>Expiry Date:</div>
          <div className={styles.documentValue}>{document.expiryDate ? new Date(document.expiryDate).toLocaleDateString() : <span className={styles.textMuted}>N/A</span>}</div>
          <div className={styles.documentLabel}>Status:</div>
          <div className={styles.documentValue}>
            {isExpired ? (
              <span className={styles.documentExpired}>Document Expired</span>
            ) : (
              <span className={styles.documentValid}>Valid</span>
            )}
          </div>
        </div>
        <button className={buttonStyles.button + ' ' + buttonStyles.download} onClick={() => handleDocumentDownload(document.id)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor" className={styles.downloadIcon}>
            <path d="M9 3a1 1 0 1 1 2 0v7.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4A1 1 0 0 1 5.707 8.293L8 10.586V3z"/>
            <path d="M4 15a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1z"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default DocumentViewer;
